<router-outlet
  ><cam-alert-toast class="global-toast"></cam-alert-toast
></router-outlet>
<p-toast key="horus-unavailable" [preventDuplicates]="true" />
@if (showNotificationPopup()) {
  <app-notification-permission />
}
